module.exports = __webpack_public_path__ + "static/img/market.15524b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ucenter/market.png
// module id = 2381
// module chunks = 68